<template>
  <div>
    <div class="homebox clearfix">
      <!-- 首页的头部 -->
      <Head />
      <!-- 首页的头部 -->
      <!-- 轮播banner -->
      <BannerList />
      <div class="owin-height">
        <div class="main-wrapper course-notice">
          <div>
            <!-- 精品MOOC开放课 -->
            <Course :courseType="2" />
            <!-- 精品SPOC校本课 -->
            <Course :courseType="1" />
          </div>
          <div class="notice-wrapper">
            <LoginCard />
            <News />
          </div>
        </div>
        <!-- 友情链接 -->
      </div>
      <!-- 教学数据 -->
      <TeachData />
      <!-- 推荐教师 -->
      <TeacherList />
      <!-- 教师弹窗 -->
      <div class="fixed-shady"></div>
    </div>
    <!-- 教师弹窗 -->
    <DialogTeacherDetail />
    <Footer />
  </div>
</template>

<script>
import Head from "./../components/Head";
import DialogTeacherDetail from "./../components/DialogTeacherDetail";
import Footer from "./../components/Footer";
import Course from "./components/Course";
import TeacherList from "./components/TeacherList";
import BannerList from "./components/BannerList";
import TeachData from "./components/TeachData";
import LoginCard from "./components/LoginCard";
import News from "./components/News";
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    TeachData,
    LoginCard,
    DialogTeacherDetail,
    Footer,
  }
};
</script>